import React from 'react'

const FixedTextTableData = ({ text }) => {
	return <td>{text ? text : '-'}</td>
}

export default FixedTextTableData
